import './request-info.scss';
import {useIntl} from "react-intl";
import {Field} from 'formik';
import {typeIdentification} from '../../../__mocks__/data';
import _ from 'lodash';
import {WLOCreditAPIService, AniConsultaError} from '../../../services';
import toast from "react-hot-toast";
import {useLoginContext} from '../../../hooks/useLoginContext';
import {useRequestContext} from '../../../hooks/useRequestContext';
import {ANIPersona, CygnusPersona} from '../../../context/RequestContext';
import {useEffect, useState} from 'react';
import ClockLoader from "react-spinners/ClockLoader";

interface FormKnowYouProps {
    errors?: any,
    values?: any,
}
export function FormKnowYou(props: FormKnowYouProps) {
    const {user} = useLoginContext();
    const {request, setRequest} = useRequestContext();
    const [isLoadingInfo, setIsLoadingInfo] = useState(false);
    const [disabledInputs, setDisabledInputs] = useState(true);
    const {errors, values} = props;
    const intl = useIntl();
    const isBlank = (value?: string) => !value || value.trim() === '';
    const getPolizaFallback = () => {
        const raw = sessionStorage.getItem('datos_Poliza');
        if (!raw) return null;
        try {
            const data = JSON.parse(raw);
            return {
                nombres: data.Pws_Nombres || '',
                apellido1: data.Pws_Apellidos1 || '',
                apellido2: data.Pws_Apellidos2 || '',
                email: data.email || ''
            };
        } catch {
            return null;
        }
    };
    const applyPolizaFallback = () => {
        const poliza = getPolizaFallback();
        if (!poliza) return;
        if (isBlank(values.Pws_Nombres) && !isBlank(poliza.nombres)) {
            values.Pws_Nombres = poliza.nombres;
        }
        if (isBlank(values.Pws_Apellidos1) && !isBlank(poliza.apellido1)) {
            values.Pws_Apellidos1 = poliza.apellido1;
        }
        if (isBlank(values.Pws_Apellidos2) && !isBlank(poliza.apellido2)) {
            values.Pws_Apellidos2 = poliza.apellido2;
        }
        if (isBlank(values.Pws_Correo) && !isBlank(poliza.email)) {
            values.Pws_Correo = poliza.email;
        }
    };
    useEffect(() => {
        console.log("FormKnowYou");
        const datosPersonaString = sessionStorage.getItem("personaValidada");
        if (datosPersonaString) {
            const datosPersona = JSON.parse(datosPersonaString);
            const numDoc = datosPersona.numIdenVal;
            const numTipoDoc = datosPersona.tipIdenVal;
            if (numDoc) {
            values.Pws_Identificacion = numDoc;
            }
            if (numTipoDoc) {
            values.Pws_Tip_Identificacion = numTipoDoc;
            }
        }
        handleSearch()
    }, []);
    const handleSearch = async () => {
        let consultaANI = false;
        setIsLoadingInfo(true);
        const datosPersona = sessionStorage.getItem('personaValidada');
        if (datosPersona){
                    if( !isNaN(values.Pws_Identificacion)){
                        try {
                            const person = await WLOCreditAPIService.consultaSolicitudCygnus({
                                Pws_Tip_Identificacion: values.Pws_Tip_Identificacion!,
                                Pws_Identificacion: values.Pws_Identificacion!
                            });
                            if (!_.isEmpty(person.payload)) {
                                if (person.payload.result === "1") {
                                    const pCygnus = person.payload.data.datos_persona.Datos_persona[0] as CygnusPersona;
                                    values.Pws_Apellidos1=pCygnus.Pws_Apellidos1;
                                    values.Pws_Apellidos2=pCygnus.Pws_Apellidos2;
                                    values.Pws_Nombres=pCygnus.Pws_Nombres;
                                    console.log("PERSONA CYGNUS en formKnowYou",pCygnus)
                                    
                                    // Si se obtienen datos de Cygnus, verificar si están completos
                                    // Si falta nombre o primer apellido, habilitar campos para completar
                                    const hasNames = !!(pCygnus.Pws_Nombres && pCygnus.Pws_Nombres.trim() !== '');
                                    const hasLastName1 = !!(pCygnus.Pws_Apellidos1 && pCygnus.Pws_Apellidos1.trim() !== '');
                                    // Si no tiene nombres o apellidos completos, habilitar campos
                                    setDisabledInputs(hasNames && hasLastName1);
                                    
                                    // Si faltan datos, limpiar campos para que el usuario los complete
                                    if (!hasNames || !hasLastName1) {
                                        if (!hasNames) values.Pws_Nombres = "";
                                        if (!hasLastName1) {
                                            values.Pws_Apellidos1 = "";
                                            values.Pws_Apellidos2 = "";
                                        }
                                        applyPolizaFallback();
                                    }
                                    
                                    setRequest({...request, personCygnus: pCygnus, searchANI: false, errorConsulta: false});
                                    sessionStorage.setItem('person', JSON.stringify(person.payload.data.datos_persona.Datos_persona[0]));
                                    setIsLoadingInfo(false);
                                } else {
                                    try {
                                    const personANI = await WLOCreditAPIService.consultaSolicitudANI({
                                        Pws_Tip_Identificacion: values.Pws_Tip_Identificacion!,
                                        Pws_Identificacion: values.Pws_Identificacion!,
                                        Pws_fecha_expedicion: localStorage.getItem('fechaExp') || '',
                                    });
                                    
                                    const pANI = personANI as ANIPersona;
                                    const fecha = personANI.fechaExpedicion.split('/');
                                    if(pANI.primerNombre && pANI.primerApellido){
                                        values.Pws_Apellidos1=pANI.primerApellido;
                                        values.Pws_Apellidos2=pANI.segundoApellido;
                                        values.Pws_Nombres=pANI.primerNombre+" "+pANI.segundoNombre;
                                        // Si se obtienen datos de ANI, deshabilitar campos
                                        setDisabledInputs(true);
                                    }else{
                                        console.log("no hay datos en ani")
                                        // Si no hay datos, habilitar campos para que el usuario los ingrese
                                        setDisabledInputs(false);
                                        values.Pws_Apellidos1="";
                                        values.Pws_Apellidos2="";
                                        values.Pws_Nombres="";
                                        applyPolizaFallback();
                                    }
                                    values.Pws_Fec_expe= fecha[2]+'-'+fecha[1]+'-'+fecha[0]
                                    pANI.fechaExpedicion = fecha[2]+'-'+fecha[1]+'-'+fecha[0]
                                    setIsLoadingInfo(false);
                                    setRequest({...request, personANI: pANI, searchANI: true, errorConsulta: false});
                                    sessionStorage.setItem('person', JSON.stringify(person));
                                    } catch (aniError) {
                                        if (aniError instanceof AniConsultaError && aniError.allowManual) {
                                            setDisabledInputs(false);
                                            applyPolizaFallback();
                                            setRequest({...request, searchANI: false, errorConsulta: false});
                                            setIsLoadingInfo(false);
                                        } else {
                                            throw aniError;
                                        }
                                    }
                                }
                            }else{
                                toast.error('En estos momentos no podemos atender su solicitud',{
                                    duration:5000,
                                });
                                // Si no se obtienen datos, habilitar campos para ingreso manual
                                setDisabledInputs(false);
                                applyPolizaFallback();
                                setIsLoadingInfo(false);
                            }
                        } catch (e) {
                            const error = e as any;
                            // Habilitar campos para ingreso manual cuando hay error
                            setDisabledInputs(false);
                            applyPolizaFallback();
                            if (!_.isEmpty(error.response?.data)) {
                                setRequest({...request, errorConsulta: true});
                                const menssage = error.response.data as any;
                                toast.error("El documento de identificación no existe.",{
                                    duration:5000,
                                });
                                setTimeout(() => {
                                    setIsLoadingInfo(false);
                                }, 5000);
                        } else {
                            setRequest({...request, errorConsulta: true});
                            toast.error('En estos momentos no podemos atender su solicitud',{
                                duration:5000,
                            });
                            setTimeout(() => {
                                setIsLoadingInfo(false);
                            }, 5000);
                            
                        }
                        }
                    }else{
                        toast.error("El documento de identificacion debe ser numerico",{
                            duration:5000,
                        })
                    }
        }
    }

    return (
        <div className={'row'}>
            <ClockLoader id='spinner' color={"#009694"} loading={isLoadingInfo} size={100}/>
            <div className={"title-medium-red"}>{intl.formatMessage({id: "form_credit_information_title"})}</div>
            <div className={"subtitle-medium"}>{intl.formatMessage({id: "form_credit_information_subtitle"})}</div>
            <div className={'flex-container-form-know-you'}>
                <div className={"flex-container-form-know-you-item-right flex-grow-6"}>
                    <Field as="select"
                        id={"Pws_Tip_Identificacion"}
                        name={"Pws_Tip_Identificacion"}
                        className={`${errors.Pws_Tip_Identificacion ? 'form-know-you-item-input-small input-error' : 'form-know-you-item-input-small'}`}
                        >
                        {typeIdentification && typeIdentification.WS_TIPOS_IDENTIFICACION_IResult.LstTiposIdent.Datos_TiposIdentificacion.map((item, key: number) => {
                            return (
                                <option key={key} value={item.s_codigo}>{item.s_descripcion}</option>
                            )
                        })}
                    </Field>
                </div>
                <div className={"flex-container-form-know-you-item-left flex-grow-6"}>
                    <Field id={"Pws_Identificacion"}
                        name={"Pws_Identificacion"}
                        disabled
                        className={`${errors.Pws_Identificacion ? 'form-know-you-item-input-small input-error' : 'form-know-you-item-input-small'}`}/>
                </div>
            </div>
            <div className={'flex-container-form-know-you'}>
                <div className={"flex-container-form-know-you-item-center flex-grow-6"}>
                    <Field id={"Pws_Nombres"}
                        name={"Pws_Nombres"}
                        disabled={disabledInputs}
                        className={`${errors.Pws_Nombres ? 'form-know-you-item-input-large input-error' : 'form-know-you-item-input-large'}`}
                        placeholder={"Nombres"}/>
                </div>
            </div>
                <div className={'flex-container-form-know-you'}>
                <div className={"flex-container-form-know-you-item-right flex-grow-6"}>
                    <Field id={"Pws_Apellidos1"}
                        name={"Pws_Apellidos1"}
                        disabled={disabledInputs}
                        className={`${errors.Pws_Apellidos1 ? 'form-know-you-item-input-small input-error' : 'form-know-you-item-input-small'}`}
                        placeholder={'Primer Apellido'}/>
                </div>
                <div className={"flex-container-form-know-you-item-left flex-grow-6"}>
                    <Field id={"Pws_Apellidos2"}
                        name={"Pws_Apellidos2"}
                        disabled={disabledInputs}
                        className={`${errors.Pws_Apellidos2 ? 'form-know-you-item-input-small input-error' : 'form-know-you-item-input-small'}`}
                        placeholder={'Segundo Apellido'}/>
                </div>
                </div>
            <div className={'flex-container-form-know-you'}>
                <div className={"flex-container-form-know-you-item-right flex-grow-6"}>
                    <Field id={"Pws_Telefono1"}
                        name={"Pws_Telefono1"}
                        className={`${errors.Pws_Telefono1 ? 'form-know-you-item-input-small input-error' : 'form-know-you-item-input-small'}`}
                        placeholder={intl.formatMessage({id: "placeholder_phone_1"})}/>
                </div>
                <div className={"flex-container-form-know-you-item-left flex-grow-6"}>
                    <Field id={"Pws_Correo"}
                        name={"Pws_Correo"}
                        className={`${errors.Pws_Correo ? 'form-know-you-item-input-small input-error' : 'form-know-you-item-input-small'}`}
                        placeholder={intl.formatMessage({id: "placeholder_mail"})}/>
                </div>
            </div>
            <div className={'flex-container-form-know-you'}>
                <div className={"flex-container-form-know-you-item-right flex-grow-6"}>
                    <Field id={"Pws_Telefono2"}
                        name={"Pws_Telefono2"}
                        className={`${errors.Pws_Telefono2 ? 'form-know-you-item-input-small input-error' : 'form-know-you-item-input-small'}`}
                        placeholder={intl.formatMessage({id: "placeholder_phone_2"})}/>
                </div>
                <div className={"flex-container-form-know-you-item-left flex-grow-6"}>
                    <Field id={"mail_confirmation"}
                    onPaste={(e:any)=>{
                        e.preventDefault()
                        return false;
                    }} 
                    autoComplete="off"
                    name={"mail_confirmation"}
                    className={`${errors.mail_confirmation ? 'form-know-you-item-input-small input-error' : 'form-know-you-item-input-small'}`}
                    placeholder={intl.formatMessage({id: "placeholder_mail_confirmation"})}/>
                </div>
            </div>
            <div className={'flex-container-form-know-you'}>
                <div className={"flex-container-form-know-you-item-center flex-grow-6"}>
                    <Field id={"Num_poliza"}
                        name={"Num_poliza"}
                        className={`${errors.Num_poliza ? 'form-know-you-item-input-large input-error' : 'form-know-you-item-input-large'}`}
                        placeholder={"Numero de poliza"}/>
                </div>
            </div>
        </div>

    )
}